import { createLitComponent } from "../lib/create-lit-component.js";
import { GivebutterButton } from "@givebutter/widgets-core";
//#region src/components/GivebutterButton.tsx
const GivebutterButton$1 = createLitComponent({
	elementClass: GivebutterButton,
	tagName: "givebutter-button"
});
//#endregion
export { GivebutterButton$1 as GivebutterButton };
